export const REQUEST_NOTIFICATIONS = "@@NOTIFICATIONS/REQUEST_NOTIFICATIONS";
export const SUCCESS_NOTIFICATIONS = "@@NOTIFICATIONS/SUCCESS_NOTIFICATIONS";
export const FAILURE_NOTIFICATIONS = "@@NOTIFICATIONS/FAILURE_NOTIFICATIONS";

export default (state: any, action: any) => {
  switch (action.type) {
    case REQUEST_NOTIFICATIONS:
      return {
        ...state,
        loading: true,
        notifications: [],
      };

    case SUCCESS_NOTIFICATIONS:
      const recentNotification = action.payload.filter((not: any) => !not.read);
      // const recentNotification = action.payload;
      return {
        ...state,
        recentNotification: recentNotification[0] ? recentNotification[0] : {},
        notifications: action.payload,
        loading: false,
      };

    case FAILURE_NOTIFICATIONS:
      return {
        ...state,
        notifications: state.notifications,
        loading: false,
      };

    default:
      return state;
  }
};
